import { render, staticRenderFns } from "./card-details.vue?vue&type=template&id=0519d9f8&"
import script from "./card-details.vue?vue&type=script&lang=js&"
export * from "./card-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports